export default "__VITE_ASSET__CEVS7z5Z__"